/**
 * TASK-162 — builds the display label for an authority record in search/list/picker
 * contexts where the cataloging "viz" cross-reference is meaningful.
 *
 * Display contract (preferred = `item.headingValue`):
 *
 * | Match path                                  | Returned label                              |
 * |---------------------------------------------|---------------------------------------------|
 * | PREFERRED hit / no query / no `matchedHeading` | `preferred`                                 |
 * | VARIANT hit, `matchedHeading !== preferred` | `"{preferred} (varianta: {matched})"` (cs)  |
 *
 * The suffix wording is sourced from the message id `ui-czna-authorities.search.variantSuffix`
 * so it stays localizable (CS: "varianta: …", EN: "variant: …"). Whitespace-only or empty
 * `matchedHeading` collapses to the null branch — the same effective behavior the BE has
 * (BE never sends an empty matched, but defensive on the FE keeps the contract symmetrical).
 *
 * The helper is intentionally pure (no React, no DOM) so it can be reused by the
 * AuthoritiesList cell renderer AND `useRecordPickerOptions` formatter without
 * each call site re-implementing the same construction logic.
 */
export var formatHeadingLabel = function (item, intl) {
    var _a, _b;
    var headingValue = (_a = item.headingValue) !== null && _a !== void 0 ? _a : '';
    var matched = (_b = item.matchedHeading) === null || _b === void 0 ? void 0 : _b.trim();
    if (!matched || matched === headingValue) {
        return headingValue;
    }
    var suffix = intl.formatMessage({ id: 'ui-czna-authorities.search.variantSuffix' }, { value: matched });
    return "".concat(headingValue, " (").concat(suffix, ")");
};
